<!--<template>-->
<!--	<div class="h-panel-body padding font-bold">-->
<!--		<h3 class="margin text-center" v-if="!Object.keys(dataList).length">亲，目前没有已结账的期间！</h3>-->
<!--		<template v-for="year in years">-->
<!--			<h2 class="margin-bottom">{{year}}年</h2>-->
<!--			<Row :space="20">-->
<!--				<Cell v-for="month in dataList[year]" :key="year+month.checkMonth" width="3" v-if="month.status==2">-->
<!--					<div class="period" :class="{disable:month.disable,completed:month.status==2}" @click="unCheck(month)">-->
<!--						<div class="bg-primary-color month-header"></div>-->
<!--						{{month.checkMonth}}月-->
<!--					</div>-->
<!--				</Cell>-->
<!--			</Row>-->
<!--		</template>-->
<!--	</div>-->
<!--</template>-->

<template>
  <div class="h-panel-body padding font-bold">
    <h3 class="margin text-center" v-if="!Object.keys(dataList).length">亲，目前没有已结账的期间！</h3>
    <template v-for="year in years">
      <h2 class="margin-bottom">{{year}}年</h2>
      <Row :space="20">
        <Cell v-for="month in dataList[year]" :key="year+month.checkMonth" width="3">
          <div class="period" :class="{disable: month.disabled, completed: month.status==2}" @click="!month.disabled && unCheck(month)">
            <div class="bg-primary-color month-header">
              <i class="fa fa-lock white-color"></i>
            </div>
            {{month.checkMonth}}月
          </div>
        </Cell>
      </Row>
    </template>
  </div>
</template>


<script>
/**
	 * 反结账
	 */
	export default {
		name: "UnCheckOut",
		data() {
			return {
				dataList: {}
			}
		},
		computed: {
			years() {
				return Object.keys(this.dataList).sort((a, b) => b - a);
			}
		},
		methods: {
      /**
       * 加载已结账的会计期间列表数据
       *
       * 该方法从后端获取所有会计期间数据，并过滤出已结账状态（status=2）的期间，
       * 然后按年度进行分组整理，最终更新组件的 dataList 数据供模板渲染使用。
       *
       * @returns {void} 无返回值，通过 this.dataList 更新组件状态
       */
			loadList() {
        // 调用后端 API 获取会计期间列表数据
				this.$api.checkout.list().then(({data}) => {
          // 创建按年份分组的对象，用于存储已结账的期间数据
          // key: 年度（checkYear）
          // value: 该年度下所有已结账期间的数组
					let checkData = {};
          // 遍历所有期间数据，筛选并分组已结账的期间
					data.forEach(val => {
            // 只处理状态为已结账（status=2）的期间
						if (val.status == 2) {
              // 如果当前年份尚未在 checkData 中创建数组，则先初始化
							if (!checkData[val.checkYear]) {
								checkData[val.checkYear] = [];
							}
              // 将已结账期间添加到对应年份的数组中
							checkData[val.checkYear].push(val);
						}
					});

          // 对每个年份的已结账期间进行排序，并标记是否可选
          // 只有最新的（月份最大的）已结账期间才允许反结账
          Object.keys(checkData).forEach(year => {
            // 按月份降序排序，月份最大的排在最前面
            checkData[year].sort((a, b) => b.checkMonth - a.checkMonth);

            // 遍历时给每条记录添加 disabled 标记
            checkData[year].forEach((item, index) => {
              // 只有第一条（月份最大的）记录可选，其他都禁用
              item.disabled = index !== 0;
            });
          });


          // 将分组后的已结账期间数据赋值给组件的 dataList 属性
          // 模板中的 v-for 循环会使用此数据进行渲染
					this.dataList = checkData;
				})
			},
      /**
       * 执行反结账操作
       *
       * 对指定的会计期间执行反结账处理，操作流程如下：
       * 1. 显示确认对话框，用户确认后继续操作
       * 2. 显示加载提示，告知用户正在处理中
       * 3. 调用后端 API 执行反结账
       * 4. 反结账完成后重新加载列表数据
       *
       * @param {Object} data - 会计期间数据对象
       * @param {string|number} data.checkYear - 结账年度，用于标识要反结账的年份
       * @param {string|number} data.checkMonth - 结账月份，用于标识要反结账的月份
       * @returns {void} 无返回值，执行异步操作后刷新列表并关闭加载提示
       */
			unCheck(data) {
        // 显示确认对话框，提示用户确认是否进行反结账操作
        // 标题为"反结账操作"，内容为"确定进行反结账？"
				this.$Confirm("确定进行反结账 ?", "反结账操作").then(() => {
          // 用户点击确认后，显示全局加载提示
          // 提示文案为"正在反结账中..."，防止用户重复操作
					this.$Loading("正在反结账中...");
          // 调用后端 API 执行反结账操作
          // 传递需要反结账的年度和月份参数
					this.$api.checkout.unCheck({year: data.checkYear, month: data.checkMonth}).then(() => {
            // 反结账成功后，重新加载列表数据
            // 结账成功后显示提示信息
            this.$Message("反结账完成啦！");
            // 分发 Vuex action 刷新全局状态数据
            // 'init' action 会重新初始化应用的状态，确保数据是最新的
            // this.$store.dispatch('init');
            // // 确保页面显示的是最新的结账状态
						// this.loadList();
            // 等待 init 完成后再加载列表，确保 checkoutList 已更新
            this.$store.dispatch('init').then(() => {
              // 确保页面显示的是最新的结账状态
              this.loadList();
            });

					}).finally(() => {
            // 无论请求成功或失败，最终都关闭加载提示
            // 恢复用户可以继续其他操作的状态
						this.$Loading.close();
					});
				});
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>


<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		border-radius: 5px;
		text-align: center;
		font-size: 20px;
		color: #000;
	}

	.period {
		border-radius: 3px;
		text-align: center;
		line-height: 54px;
		border: 1px solid #929292;
		white-space: nowrap;
		overflow: hidden;
		box-sizing: border-box;
		height: 80px;

		&:hover {
			cursor: pointer;
			box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
		}

    // 禁用状态样式 - 显示灰色且不可点击
    &.disable {
      background-color: #f5f5f5;
      color: #ccc;
      border-color: #e0e0e0;
      cursor: not-allowed;

      &:hover {
        box-shadow: none;
      }

      .month-header {
        background-color: #dcdcdc !important;
      }
    }
		.month-header {
			height: 25px;
			margin: -8px -8px 0 -8px;
		}

		&.completed {
			.month-header {
				background-color: #929292 !important;
				line-height: 20px;
			}

			color: #929292;
		}
	}
</style>
